import React, {FC} from 'react'
import {Spinner} from '@mdsol/onex-design'

import './loading.scss'

export interface ChartLoadingPropsType {
  chartType?: string,
}

const Loading: FC<ChartLoadingPropsType> = ({chartType}) => {
  const loadingClassName = chartType === 'bar-chart' ? 'bar-chart-loading' : 'donut-chart-loading'

  return (
    <div className={`${loadingClassName}`}>
      <Spinner dataTestId='chart-loading-spinner' size='lg' />
    </div>
  )
}

export default Loading
